import React from "react"
import "./SideContainer.css"

export default function SideContainer({ children, classes }) {
  return <div className={`sideCon ${classes}`}>{children}</div>
}
